import { createTheme } from '@mui/material/styles';

import palette from './palette';
import typography from './typography';
import overrides from './overrides';

// const mappedOverdires = Object.entries(overrides).map(([component, styles]) => ([
//   component, {
//     styleOverrides: {
//       ...styles,
//     },
//   },
// ]));
// const newOverrides = Object.fromEntries(mappedOverdires);

const themeOptions = {
  palette,
  typography,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: '0.875rem',
          lineHeight: 2,
          letterSpacing: '0.01071em',
        },
      },
    },
    // ...newOverrides,
    MuiButton: {
      styleOverrides: {
        ...overrides.MuiButton,
      },
    },
  },
  container: { width: 756, smWidth: 575 },
};

const theme = createTheme(themeOptions);

export default theme;
